import OscarInvoicePendingAlertHtml from './templates/oscar.invoice-pending.alert.html';
import OscarRequestInvoiceHtml      from './oscar.request-invoice.html';

export function OscarInvoicesService (
  $uibModal, 
  $q, 
  $translate, 
  confirm, 
  sessionObjAPI, 
  workshopAPI
) {
  const OscarInvoices = function (invoice, vehicle) {
    this.Invoice = invoice;
    this.origin  = sessionObjAPI.base().origin;
    this.vehicle = vehicle || {};
  };

  OscarInvoices.prototype.addItems = function () {
    const self = this;

    return $q.when().then(() => {
      return self.Invoice.invoice.id ? $q.when(self.Invoice.invoice) :
        confirm.remember($translate.instant('JS_SPACE.INTEGRATIONS.INVOICE_MUST_FIRST_BE_SAVED', { name: 'Oscar' }), null, 'oscarInvoicesAutoSave').then(() => {
          return self.Invoice.save();
        });
    }).then(invoice => {
      if (invoice.current_oscar_order) {
        return self.checkOscarAvailability(invoice).then(() => {
          return self.createOscarOrder(invoice);
        }).catch(() => {
          return self.invoicePendingAlert(invoice);
        });
      }

      return self.createOscarOrder(invoice);
    });
  };

  OscarInvoices.prototype.checkOscarAvailability = function (invoice) {
    const self = this;

    return workshopAPI.get('/oscar/check_oscar_id_for_invoice', invoice.id).then(requestId => {
      return requestId === '0' ? $q.reject($translate.instant('JS_SPACE.OSCAR.ORDER_NOT_COMPLETED')) : $q.when(invoice);
    });
  };

  OscarInvoices.prototype.createOscarOrder = function (invoice) {
    const self = this;

    return workshopAPI.get('/oscar/create_oscar_order_for_invoice', invoice.id).then(data => {
      return data.order.RequestStatus != 'FAIL' ?
        workshopAPI.get('/oscar/add_oscar_request_id_to_invoice', [ data.order.RequestID, invoice.id ]) :
          $q.reject(`${data.order.RequestStatus} - ${data.order.ErrorReason}`);
    }).then(invoice => {
      return $uibModal.open({
        templateUrl: OscarRequestInvoiceHtml,
        controller : 'OscarRequestInvoiceCtrl',
        windowClass: 'lg-modal',
        resolve    : {
          invoice () {
            return invoice;
          },
          customer () {
            return workshopAPI.get('/customer', invoice.customer_id)
          }
        }
      }).result;
    })
  };

  OscarInvoices.prototype.getOscarItems = function (invoice) {
    const self = this;

    return self.checkOscarAvailability(invoice).then(invoice => {
      return workshopAPI.get('/oscar/get_single_oscar_order_for_invoice', [ invoice.current_oscar_order, invoice.id ]);
    }).then(items => {
      return workshopAPI.post('/oscar/add_oscar_items_to_invoice', items, 'items');
    }).then(data => {
      return workshopAPI.get('/oscar/remove_oscar_request_id_from_invoice', data);
    }).then(() => {
      return $q.when($translate.instant('JS_SPACE.OSCAR.OSCAR_PARTS_ADDED'));
    });
  };

  OscarInvoices.prototype.invoicePendingAlert = function (invoice) {
    const self = this;

    return $uibModal.open({
      templateUrl: OscarInvoicePendingAlertHtml,
      controller : 'OscarRequestInvoiceCtrl',
      windowClass: 'lg-modal',
      resolve    : {
        invoice () {
          return invoice;
        },
        customer () {
          return workshopAPI.get('/customer', invoice.customer_id);
        }
      }
    }).result;
  };

  OscarInvoices.prototype.overwrite = function (invoice) {
    const self = this;

    return workshopAPI.get('/oscar/remove_oscar_request_id_from_invoice', invoice.id).then(data => {
      return workshopAPI.get('/oscar/create_oscar_order_for_invoice', data.id);
    }).then(data => {
      return workshopAPI.get('/oscar/add_oscar_request_id_to_invoice', [ data.order.RequestID, invoice.id ]);
    }).then(invoice => {
      return $uibModal.open({
        templateUrl: OscarRequestInvoiceHtml,
        controller : 'OscarRequestInvoiceCtrl',
        windowClass: 'lg-modal',
        resolve    : {
          invoice () {
            return invoice;
          },
          customer () {
            return workshopAPI.get('/customer', invoice.customer_id);
          }
        }
      }).result;
    });
  };

  return OscarInvoices;
}
